export const COLUMNS = [
  { id: 'name', label: 'Название', minWidth: 150 },
  { id: 'number', label: 'Порядковый номер', minWidth: 50 },
  { id: 'collection', label: 'Коллекция', minWidth: 150 },
  { id: 'category', label: 'Категория', minWidth: 150 },
  { id: 'brand', label: 'Бренд', minWidth: 150 },
  { id: 'inStock', label: 'В наличии', minWidth: 50 },
  { id: 'liked', label: 'Избранный', minWidth: 50 },
  {
    id: 'population',
    label: 'Действия',
    minWidth: 50,
  },
];
